// hooks/useTrainingNotifications.js
import { useEffect, useState } from 'react';
import newsSocketService from '../services/newsSocketService';

export const useTrainingNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    // Connect once
    newsSocketService.connect();

    const handleTrainingCompletion = (data) => {
      const notification = {
        id: `${data.app_name}-${Date.now()}`,
        appName: data.app_name,
        tenantId: data.tenant_id,
        timestamp: new Date(data.timestamp),
        message: `App "${data.app_name}" training completed successfully!`,
        changes: data.changes,
        read: false
      };
      
      setNotifications(prev => [notification, ...prev].slice(0, 20));
      setUnreadCount(prev => prev + 1);
    };

    const unsubscribe = newsSocketService.subscribe('training_completion', handleTrainingCompletion);

    return () => unsubscribe();
  }, []);

  const markAsRead = (id) => {
    setNotifications(prev => 
      prev.map(n => n.id === id ? { ...n, read: true } : n)
    );
    setUnreadCount(prev => Math.max(0, prev - 1));
  };

  const markAllAsRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    setUnreadCount(0);
  };

  const clearAll = () => {
    setNotifications([]);
    setUnreadCount(0);
  };

  return {
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead,
    clearAll
  };
};